import React from 'react';

import styled from 'styled-components';
import { prop } from 'styled-tools';

import LazyLoadWithSkeleton from 'components/LazyLoadWithSkeleton';

import { AssetI } from 'interfaces/content-stack/contentStack.types';

import { autoOptimizeImage, optimizeImageHeight } from 'utils/functions';

const StyledCollage = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .lazyload-wrapper {
    display: flex;
    flex: 1 0 50%;
    width: 100%;

    &.collage-top {
      height: 13.375rem;
    }

    &.collage-bottom {
      height: 12.1875rem;
    }
  }

  .skeleton-container {
    width: 100%;
  }
`;

const CollageImage = styled.div<{ alt?: string; $imageUrl?: string }>`
  background-image: url('${prop('$imageUrl')}');
  background-repeat: no-repeat;
  display: flex;
  background-size: cover;
  background-position: center;
  flex: 1 0 50%;

  &.collage-top {
    height: 13.375rem;
    width: 100%;
  }

  &.collage-bottom {
    height: 12.1875rem;
  }
`;

type Props = {
  altText?: string | undefined;
  images?: AssetI[] | undefined;
};

const Collage: React.FC<Props> = ({ altText, images }) => {
  const classNames: { [key: number]: string } = {
    0: 'collage-top-left collage-top',
    1: 'collage-top-right collage-top',
    2: 'collage-bottom',
  };

  return (
    <StyledCollage>
      {images?.map((image, index) => {
        return (
          <LazyLoadWithSkeleton key={index} borderRadius={0} className={classNames[index]}>
            <CollageImage
              alt={altText}
              className={classNames[index]}
              $imageUrl={
                index < 2 ? optimizeImageHeight(image?.url, '214') : autoOptimizeImage(image?.url, true, '720')
              }
            />
          </LazyLoadWithSkeleton>
        );
      })}
    </StyledCollage>
  );
};

export default Collage;
